function Hero() {
  const heroes = document.querySelectorAll(".c-hero");

  if (!heroes.length) return;

  heroes.forEach(setupHeroVideo);
}

function setupHeroVideo(hero) {
  const video = hero.querySelector(".c-hero__video");
  if (!video) return;

  const mediaQuery = video.dataset.mediaQuery;

  // If no media query, just load once
  if (!mediaQuery) {
    updateVideoSource(video);
    return;
  }

  const mq = window.matchMedia(mediaQuery);

  // initial load
  updateVideoSource(video, mq.matches);

  // react to changes
  mq.addEventListener("change", (e) => {
    updateVideoSource(video, e.matches);
  });
}

function updateVideoSource(video, isMobile) {
  const source = video.querySelector("source");
  if (!source) return;

  const mobile = video.dataset.srcMobile;
  const desktop = video.dataset.srcDesktop;

  const hasBoth = mobile && desktop;

  let newSrc = null;

  // If both exist → use breakpoint
  if (hasBoth) {
    newSrc = isMobile ? mobile : desktop;
  }
  // If only one exists → always use it
  else {
    newSrc = mobile || desktop;
  }

  if (!newSrc) {
    video.style.display = "none";
    return;
  }

  video.style.display = "";

  const newSrcAbsolute = new URL(newSrc, window.location.href).href;

  if (source.src === newSrcAbsolute) return;

  source.src = newSrc;
  video.load();
}

export default Hero;
